<template>
  <div v-if="HygienistForDispute[0] || LocationForDispute[0]">
    <v-row justify="space-between">
      <v-col><v-subheader>Tip: Click on chip to copy value</v-subheader></v-col>
      <v-col class="text-end">
        <v-btn large color="primary" @click="$emit('next')">
          New search <v-icon>autorenew</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <div>
      <v-row class="ml-4" align-content="start">
        <v-col v-if="HygienistForDispute[0]" class="text-center">
          <v-chip
            @click="
              copy(
                HygienistForDispute[0].firstName +
                  HygienistForDispute[0].lastName
              )
            "
            class="ma-4 text-center"
          >
            {{
              `${HygienistForDispute[0].firstName} ${HygienistForDispute[0].lastName}`
            }}
          </v-chip>
          <br />
          {{
            `${HygienistForDispute[0].city}, ${HygienistForDispute[0].province}`
          }}
          <v-card>
            <v-timeline dense align-center>
              <v-timeline-item
                class="text-left"
                small
                v-for="(value, key) in hygienistDetails"
                :key="key"
              >
                <v-col class="pa-0">
                  {{ key }}:
                  <strong v-if="!isEditableHygienistField(key)">{{
                    value
                  }}</strong>
                  <!-- Add editable fields similar to your original component if needed -->
                </v-col>
              </v-timeline-item>
            </v-timeline>

            <v-expansion-panels :value="0" popout>
              <v-expansion-panel>
                <v-expansion-panel-header>Notes</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div
                    class="text-left"
                    @click="editNotes('Hygienist', HygienistForDispute[0])"
                  >
                    {{ HygienistForDispute[0].Notes }} &nbsp;
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <div
              class="text-center d-flex text-h6 flex-column justify-center pa-4"
            >
              <v-chip
                @click="copy(HygienistForDispute[0].email)"
                class="ma-4 text-center"
                >{{ HygienistForDispute[0].email }}</v-chip
              >
              <v-chip
                @click="copy(HygienistForDispute[0].phone)"
                class="ma-4 text-center"
                >{{ HygienistForDispute[0].phone }}</v-chip
              >
            </div>
          </v-card>
        </v-col>

        <v-col>
          <v-img
            v-if="LocationForDispute[0]"
            max-width="900"
            contain
            src="https://www.tempstars.com/wp-content/uploads/2021/03/Screen-Shot-2021-03-01-at-8.08.13-AM.png"
          ></v-img>

          <div v-if="HygienistForDispute[0]">
            <v-expansion-panels multiple class="pr-1">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Blacklisted Notes
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  {{ HygienistForDispute[0].blacklistReason }}
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  >Comments made about</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-list>
                    <v-list-item
                      v-for="(comment, i) in getCommentsForHygienist.filter(
                        comment =>
                          comment.dentistPrivateNotes != null &&
                          comment.dentistPrivateNotes.length > 0
                      )"
                      :key="i"
                    >
                      <v-list-item-content class="text-left">
                        <b>{{ comment.dentistPrivateNotes }}</b> [{{
                          comment.practiceName
                        }}]
                        <v-divider></v-divider>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header
                  >Comments made by</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-list>
                    <v-list-item
                      v-for="(comment, i) in getCommentsForHygienist.filter(
                        comment =>
                          comment.hygienistPrivateNotes != null &&
                          comment.hygienistPrivateNotes.length > 0
                      )"
                      :key="i"
                    >
                      <v-list-item-content class="text-left">
                        <b>{{ comment.hygienistPrivateNotes }}</b> [{{
                          comment.practiceName
                        }}]
                        <v-divider></v-divider>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <div v-if="HygienistForDispute[0]">
            <v-col class="d-flex flex-wrap align-center">
              <StatusReferenceValues />
              <StatusCodesTable class="ml-4" />
              <ShiftsInDialog class="mt-3 ml-4" :obj="HygienistForDispute[0]" />
              <v-btn
                color="#6A1B9A"
                dark
                class="ml-4 mt-3"
                @click="openStatsDialog"
                :loading="loadingStats"
              >
                <v-icon left small>mdi-chart-bar</v-icon>
                Stats
              </v-btn>
            </v-col>
            <!-- T2-6381: legacy Cancellation/Reinstatement course-code table
                 removed (cancellationCode / reinstatementCode / courseCode /
                 SCSMRCA reads). Course state now lives in Fair Fresh Start. -->
          </div>
        </v-col>

        <v-col v-if="LocationForDispute[0]" class="text-center">
          <v-chip
            @click="copy(LocationForDispute[0].practiceName)"
            class="ma-4 text-center"
            >{{ LocationForDispute[0].practiceName }}</v-chip
          >
          <br />
          {{
            `${LocationForDispute[0].address} ${LocationForDispute[0].city}, ${LocationForDispute[0].province}`
          }}
          <v-card>
            <v-timeline dense align-center>
              <v-timeline-item
                class="text-left"
                small
                v-for="(value, key) in locationDetails"
                :key="key"
              >
                {{ key }}: <strong>{{ value }}</strong>
              </v-timeline-item>
            </v-timeline>

            <v-expansion-panels :value="0" popout>
              <v-expansion-panel>
                <v-expansion-panel-header>Notes</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div
                    class="text-left"
                    @click="editNotes('Location', LocationForDispute[0])"
                  >
                    {{ LocationForDispute[0].notes }}
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

            <div
              class="text-center d-flex text-h6 flex-column justify-center pa-4"
            >
              <v-chip
                @click="copy(LocationForDispute[0].email)"
                class="ma-4 text-center"
                >{{ LocationForDispute[0].email }}</v-chip
              >
              <v-chip
                @click="copy(LocationForDispute[0].phone)"
                class="ma-4 text-center"
                >{{ LocationForDispute[0].phone }}</v-chip
              >
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div
      v-if="HygienistForDispute[0]"
      class="d-flex justify-center flex-wrap py-3 mb-0 mt-4"
    >
      <v-btn
        class="dark--text mx-3 my-3 px-4 py-2 font-weight-bold"
        color="green darken-2"
        :loading="manualBreakDialogLoading || isApplyingManualBreak"
        :disabled="manualBreakDialogLoading || isApplyingManualBreak"
        outlined
        @click="openManualBreakDialog"
      >
        Take a Break
      </v-btn>
      <v-btn
        class="dark--text mx-3 my-3 px-4 py-2 font-weight-bold"
        color="green darken-2"
        :loading="FirstResponseBtn"
        :disabled="FirstResponseBtn"
        outlined
        @click="
          showModal(
            0,
            `Select First Response for ${HygienistForDispute[0].firstName}`
          )
        "
      >
        First Response
      </v-btn>
      <!-- T2-6395: "Cancellations Only", "Negative Feedback" and "Quiz Received"
           course-dispute actions were removed (superseded by Fair Fresh Start
           recovery courses). -->
    </div>

    <v-dialog
      v-model="manualBreakDialog"
      max-width="520px"
      transition="dialog-transition"
      persistent
    >
      <v-card class="pb-2">
        <v-card-title style="background-color: #0B4598; color: white;">
          Take a Break
          <v-spacer></v-spacer>
          <v-btn
            icon
            dark
            :disabled="isApplyingManualBreak"
            @click="closeManualBreakDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-alert type="info" outlined dense class="mb-4">
            {{ manualBreakConfirmationCopy }}
          </v-alert>
          <v-select
            v-model="manualBreakForm.durationMonths"
            :items="manualBreakDurationOptions"
            item-text="text"
            item-value="value"
            item-disabled="disabled"
            label="Break duration"
            outlined
            dense
          ></v-select>
          <v-text-field
            v-model.trim="manualBreakForm.evidenceReference"
            label="Ticket or Evidence Reference"
            outlined
            dense
          ></v-text-field>
          <v-textarea
            v-model="manualBreakForm.note"
            label="Support note"
            outlined
            rows="4"
            auto-grow
          ></v-textarea>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            text
            :disabled="isApplyingManualBreak"
            @click="closeManualBreakDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-2"
            dark
            :loading="isApplyingManualBreak"
            :disabled="!canApplyManualBreak"
            @click="submitManualBreak"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="actionDialog"
      max-width="768px"
      transition="dialog-transition"
      persistent
    >
      <v-card class="pb-2">
        <v-card-title class="text-h5 text-center d-block mb-n2">
          {{ actionDialogTitle }}
        </v-card-title>
        <!-- T2-6381/T2-6395: legacy Quiz-Received cancellationCode /
             reinstatementCode subtitle + radios removed. -->
        <v-card-actions v-if="!courseError" class="d-block px-8">
          <v-form @submit.prevent="popFormSubmit" ref="form">
            <div>
              <v-radio-group
                v-if="formType === 0"
                v-model="selectFirstResponse_radio"
              >
                <v-radio
                  label="Checking now, I'll get back"
                  value="APT: Checking Now"
                ></v-radio>
                <v-radio
                  label="I've made adjustments and you're all set"
                  value="APT: Adjustments Made"
                ></v-radio>
                <v-radio
                  label="I haven't forgotten!"
                  value="APT: Not Forgotten"
                ></v-radio>
              </v-radio-group>

              <!-- T2-6395: formType 1/2 cancellation/reinstatement course
                   pricing radios removed with the course-dispute actions. -->

              <v-textarea
                label="Notes to Member"
                v-model="selectFirstResponse_NotesToMember"
              ></v-textarea>
              <v-textarea
                label="Internal Notes"
                v-model="selectFirstResponse_InternalNotes"
              ></v-textarea>
              <v-text-field
                label="Ticket #"
                hide-details="auto"
                v-model="selectFirstResponse_TicketNumber"
              ></v-text-field>
            </div>
            <div class="d-flex justify-space-between mt-8">
              <v-btn type="button" color="error" @click="closeModal()">
                Cancel
              </v-btn>
              <v-btn type="submit" color="success" :disabled="dissableSubmit()"
                >Submit</v-btn
              >
            </div>
          </v-form>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogNotes"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card class="pb-2">
        <v-card-title class="text-h5 text-center d-block mb-n2"
          >{{ modalNotesTitle }} Notes</v-card-title
        >
        <v-card-actions>
          <v-textarea
            outlined
            v-model="modalNotes"
            label="Note text"
          ></v-textarea>
        </v-card-actions>
        <v-card-actions class="mt-n8 d-flex justify-end">
          <v-btn
            color="success"
            class="px-6"
            @click="saveNotes(modalNotesTitle, modalNotes)"
          >
            Save
          </v-btn>
          <v-btn color="error" class="px-6" @click="dialogNotes = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- T2-6380: the "Change status" dialog was removed. Membership status is
         owned by Fair Fresh Start and is no longer manually editable from the
         dispute-resolution view. -->

    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Stats Dialog -->
    <v-dialog v-model="showStatsDialog" max-width="650px" scrollable>
      <v-card>
        <v-card-title style="background-color: #6A1B9A; color: white;">
          <v-icon left color="white">mdi-chart-bar</v-icon>
          Talent Statistics
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showStatsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text v-if="talentStats" class="pt-4" style="max-height: 500px;">
          <!-- Talent Info -->
          <v-card outlined class="mb-3">
            <v-card-subtitle class="pb-1 font-weight-bold">Talent Information</v-card-subtitle>
            <v-card-text class="pt-0">
              <v-row dense>
                <v-col cols="6"><strong>ID:</strong> {{ talentStats.hygienistId }}</v-col>
                <v-col cols="6"><strong>Name:</strong> {{ talentStats.firstName }} {{ talentStats.lastName }}</v-col>
                <v-col cols="6"><strong>Email:</strong> {{ talentStats.email || 'N/A' }}</v-col>
                <v-col cols="6">
                  <strong>Status:</strong>
                  <v-chip
                    x-small
                    :color="
                      getFairFreshStartStatusColor(talentStats.fairFreshStart)
                    "
                    text-color="white"
                    class="ml-1"
                  >
                    {{
                      getFairFreshStartVisibleLabel(talentStats.fairFreshStart)
                    }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Performance -->
          <v-card outlined class="mb-3">
            <v-card-subtitle class="pb-1 font-weight-bold">Performance</v-card-subtitle>
            <v-card-text class="pt-0">
              <v-row dense>
                <v-col cols="6">
                  <strong>Star Score:</strong>
                  <v-chip small :color="getStarColor(talentStats.starScore)" text-color="white" class="ml-1">
                    {{ talentStats.starScore !== null ? talentStats.starScore.toFixed(2) : 'N/A' }}
                    <v-icon x-small right>mdi-star</v-icon>
                  </v-chip>
                </v-col>
                <v-col cols="6">
                  <strong>Value Gives:</strong>
                  <v-chip small :color="getValueGivesColor(talentStats.valueGives)" text-color="white" class="ml-1">
                    {{ talentStats.valueGives !== null ? talentStats.valueGives : 'N/A' }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Ratings Breakdown -->
          <v-card outlined class="mb-3">
            <v-card-subtitle class="pb-1 font-weight-bold">Ratings Breakdown</v-card-subtitle>
            <v-card-text class="pt-0">
              <v-row dense>
                <v-col cols="6">
                  <strong>Total Rated Jobs:</strong> {{ talentStats.totalRatedJobs || 0 }}
                </v-col>
                <v-col cols="6">
                  <strong>5-Star Ratings:</strong>
                  <v-chip small color="green" text-color="white" class="ml-1">
                    {{ talentStats.total5StarRatings || 0 }}
                    <span v-if="talentStats.percent5Star" class="ml-1">({{ talentStats.percent5Star.toFixed(1) }}%)</span>
                  </v-chip>
                </v-col>
                <v-col cols="6">
                  <strong>Unhappy Ratings (1-2 Star):</strong>
                  <v-chip small color="red" text-color="white" class="ml-1">
                    {{ talentStats.total2StarRatings || 0 }}
                    <span v-if="talentStats.percent2Star" class="ml-1">({{ talentStats.percent2Star.toFixed(1) }}%)</span>
                  </v-chip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Job Statistics -->
          <v-card outlined class="mb-3">
            <v-card-subtitle class="pb-1 font-weight-bold">Job Statistics</v-card-subtitle>
            <v-card-text class="pt-0">
              <v-row dense>
                <v-col cols="6">
                  <strong>Jobs Completed:</strong>
                  <v-chip small color="primary" text-color="white" class="ml-1">
                    {{ talentStats.totalJobsCompleted || 0 }}
                  </v-chip>
                </v-col>
                <v-col cols="6">
                  <strong>Future Shifts:</strong>
                  <v-chip small color="blue" text-color="white" class="ml-1">
                    {{ talentStats.totalFutureShifts || 0 }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- Cancellation Stats -->
          <v-card outlined class="mb-3">
            <v-card-subtitle class="pb-1 font-weight-bold">Cancellation Statistics</v-card-subtitle>
            <v-card-text class="pt-0">
              <v-row dense>
                <v-col cols="6">
                  <strong>Total Cancelled:</strong>
                  <v-chip small :color="getCancellationColor(talentStats.cancellationPercentage)" text-color="white" class="ml-1">
                    {{ talentStats.totalCancelledShifts || 0 }}
                  </v-chip>
                </v-col>
                <v-col cols="6">
                  <strong>Cancellation %:</strong>
                  <v-chip small :color="getCancellationColor(talentStats.cancellationPercentage)" text-color="white" class="ml-1">
                    {{ talentStats.cancellationPercentage !== null ? talentStats.cancellationPercentage.toFixed(1) + '%' : 'N/A' }}
                  </v-chip>
                </v-col>
                <v-col cols="6" v-if="talentStats.cancellationScore !== undefined && talentStats.cancellationScore !== null">
                  <strong>Cancellation Score:</strong> {{ talentStats.cancellationScore }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <!-- T2-6379: Fair Fresh Start (read-only) -->
          <v-card outlined class="mb-3" v-if="talentStats.fairFreshStart">
            <v-card-subtitle class="pb-1 font-weight-bold d-flex align-center">
              Fair Fresh Start
              <v-spacer></v-spacer>
              <v-chip
                small
                :color="getFairFreshStartStatusColor(talentStats.fairFreshStart)"
                text-color="white"
              >
                <v-icon
                  v-if="
                    ffsIcon(talentStats.fairFreshStart.status.currentStatusCode)
                  "
                  left
                  x-small
                >
                  {{
                    ffsIcon(talentStats.fairFreshStart.status.currentStatusCode)
                  }}
                </v-icon>
                {{ getFairFreshStartVisibleLabel(talentStats.fairFreshStart) }}
              </v-chip>
            </v-card-subtitle>
            <v-card-text class="pt-0">
              <v-alert
                v-if="isFairFreshStartProtected(talentStats.fairFreshStart)"
                dense
                text
                border="left"
                color="amber darken-2"
                class="mb-2"
              >
                Visible status is protected as
                <strong>{{ getFairFreshStartProtectedLabel(talentStats.fairFreshStart) }}</strong>.
                Calculated/raw status is
                <strong>{{ getFairFreshStartRawLabel(talentStats.fairFreshStart) }}</strong>.
              </v-alert>
              <v-alert dense text color="#0B4598" class="mb-2">
                FFS status is based on weighted reliability, weighted feedback, completed shifts,
                and rated-shift eligibility. Percentiles are comparison context and may not match
                the status ladder directly. FFS feedback count is the scoring sample and can differ
                from Total Rated Jobs.
              </v-alert>
              <v-row dense>
                <v-col cols="6">
                  <strong>Visible status:</strong>
                  {{ getFairFreshStartVisibleLabel(talentStats.fairFreshStart) }}
                </v-col>
                <v-col cols="6">
                  <strong>Calculated/raw:</strong>
                  {{ getFairFreshStartRawLabel(talentStats.fairFreshStart) }}
                </v-col>
                <v-col cols="6">
                  <strong>Weighted reliability:</strong>
                  {{ ffsNum(talentStats.fairFreshStart.reliability.weightedReliability) }}
                </v-col>
                <v-col cols="6">
                  <strong>Reliability %ile:</strong>
                  {{ formatFairFreshStartPercentile(talentStats.fairFreshStart.reliability.percentile, talentStats.fairFreshStart.status && talentStats.fairFreshStart.status.reliabilityLabel) }}
                </v-col>
                <v-col cols="6">
                  <strong>Weighted feedback:</strong>
                  {{ ffsNum(talentStats.fairFreshStart.feedback.weightedFeedbackScore) }}
                </v-col>
                <v-col cols="6">
                  <strong>Feedback %ile:</strong>
                  {{ formatFairFreshStartPercentile(talentStats.fairFreshStart.feedback.percentile, talentStats.fairFreshStart.status && talentStats.fairFreshStart.status.feedbackLabel) }}
                </v-col>
                <v-col cols="6">
                  <strong>Completed shifts:</strong>
                  {{ ffsNum(talentStats.fairFreshStart.reliability.completedShifts) }}
                </v-col>
                <v-col cols="6">
                  <strong>FFS feedback count:</strong>
                  {{ getFairFreshStartFeedbackCount(talentStats.fairFreshStart) }}
                </v-col>
                <v-col
                  cols="12"
                  v-if="talentStats.fairFreshStart.grandfathering.isActive"
                >
                  <strong>Grandfathered as:</strong>
                  {{
                    talentStats.fairFreshStart.grandfathering
                      .protectedStatusCode || "—"
                  }}
                  ({{
                    talentStats.fairFreshStart.grandfathering.daysRemaining
                  }}
                  day(s) left)
                </v-col>
                <v-col
                  cols="12"
                  v-if="talentStats.fairFreshStart.recoveryState.overlayState"
                >
                  <strong>Recovery overlay:</strong>
                  {{ talentStats.fairFreshStart.recoveryState.overlayState }}
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

        </v-card-text>

        <v-card-text v-else-if="loadingStats" class="text-center py-8">
          <v-progress-circular indeterminate color="#6A1B9A"></v-progress-circular>
          <div class="mt-2">Loading stats...</div>
        </v-card-text>

        <v-card-text v-else class="text-center py-8">
          <v-icon large color="grey">mdi-alert-circle-outline</v-icon>
          <div class="mt-2 grey--text">No stats available</div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="justify-end pa-3">
          <v-btn color="#6A1B9A" class="white--text" @click="showStatsDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { format, utcToZonedTime } from "date-fns-tz";
import { currentTimeZone } from "@/helpers";
import {
  updateTable,
  updateCourseDisputeAnalyzer,
  getHygienistProfile,
  applyManualBreak,
  createAdminSourceCorrectionIdempotencyKey,
  uploadToS3,
  updateResumeURL,
  getHygienistStats
} from "@/api";
import StatusReferenceValues from "./components/statusReferenceValues";
import StatusCodesTable from "./components/statusCodesTable";
import ShiftsInDialog from "./components/shiftsInDialog";
import { constants } from "@/utils/constants";
import {
  getFfsStatusColor,
  getFfsStatusLabel,
  getFfsStatusIcon,
  ffsStatusNeedsDarkText,
  resolveCanonicalFfsPresentationCode
} from "@/helpers/ffsStatus";

export default {
  name: "resolveDispute",
  components: {
    StatusCodesTable,
    StatusReferenceValues,
    ShiftsInDialog
  },
  data: () => ({
    manualBreakDialog: false,
    manualBreakDialogLoading: false,
    isApplyingManualBreak: false,
    manualBreakIdempotencyKey: "",
    manualBreakForm: {
      durationMonths: 3,
      note: "",
      evidenceReference: ""
    },
    manualBreakProfile: null,
    FirstResponseBtn: false,
    valueFlagged: "<span style='color: #ff9800'>FLAGGED</span>",
    valueGood: "<span style='color: #00b908'>GOOD</span>",
    snack: false,
    snackColor: "",
    snackText: "",
    prevDate: "",
    courseError: false,
    actionDialog: false,
    actionDialogTitle: "",
    selectFirstResponse_radio: "",
    selectFirstResponse_NotesToMember: "",
    selectFirstResponse_InternalNotes: "",
    selectFirstResponse_TicketNumber: "",
    formType: 0,
    customKey: 0,
    dialogNotes: false,
    modalNotes: "",
    modalNotesTitle: "Hygienist",
    currentDispute: {},
    keepStatus: constants.keepStatus,
    keepStatusesOptions: [
      { value: 0, text: "Normal" },
      { value: 1, text: "Keep Status On" }
    ],
    file: null,
    // Stats dialog
    showStatsDialog: false,
    loadingStats: false,
    talentStats: null
  }),

  computed: {
    ...mapState(["HygienistForDispute", "LocationForDispute"]),
    ...mapGetters([
      "getLocationFormatted",
      "getHygienistFormatted",
      "getCommentsForHygienist",
      "getCommentsForLocation"
    ]),
    cancellationsPro() {
      return Math.round(
        (this.HygienistForDispute[0]["# of cancelled shifts"] -
          0.03 * this.HygienistForDispute[0]["Jobs Completed"] -
          0.03 * this.HygienistForDispute[0]["# of cancelled shifts"]) /
          0.03
      );
    },
    star5Pro() {
      return Math.round(
        (0.8 * this.HygienistForDispute[0]["# of Rated Jobs"] -
          this.HygienistForDispute[0]["# of Ratings = 5"]) /
          (1 - 0.8)
      );
    },
    star2Pro() {
      return Math.round(
        (this.HygienistForDispute[0]["# of Ratings =2"] -
          0.03 * this.HygienistForDispute[0]["# of Rated Jobs"]) /
          0.03
      );
    },
    // T2-6381/T2-6395: course pricing (formType 1/2) was removed along with the
    // cancellationCode/reinstatementCode reads.
    priceCurrentcourse() {
      return null;
    },
    selectedMembership() {
      if (this.manualBreakProfile && this.manualBreakProfile.membership) {
        return this.manualBreakProfile.membership;
      }

      const hygienist = this.HygienistForDispute[0];
      return hygienist && hygienist.membership ? hygienist.membership : null;
    },
    selectedMembershipOverlay() {
      return this.selectedMembership && this.selectedMembership.overlay
        ? this.selectedMembership.overlay
        : null;
    },
    isSelectedTalentOnABreak() {
      return (
        this.selectedMembershipOverlay &&
        this.selectedMembershipOverlay.state === "on_a_break"
      );
    },
    manualBreakDurationOptions() {
      return [
        {
          text: "Remove current break (0 months)",
          value: 0,
          disabled: !this.isSelectedTalentOnABreak
        },
        { text: "3 months", value: 3 },
        { text: "6 months", value: 6 }
      ];
    },
    manualBreakConfirmationCopy() {
      const overlay = this.selectedMembershipOverlay;
      const until =
        overlay && overlay.onABreakUntil
          ? this.formatDateTime(overlay.onABreakUntil)
          : null;

      if (this.isSelectedTalentOnABreak) {
        return until
          ? `This Talent is currently On a Break until ${until}. Choose 3 or 6 months to update it, or 0 months to remove the break.`
          : "This Talent is currently On a Break. Choose 3 or 6 months to update it, or 0 months to remove the break.";
      }

      return "This puts the Talent on a temporary FFS break immediately. A support note is required and will be saved to the Talent profile.";
    },
    canApplyManualBreak() {
      if (this.isApplyingManualBreak) {
        return false;
      }

      const duration = Number(this.manualBreakForm.durationMonths);
      const validDuration = [0, 3, 6].includes(duration);
      const note = (this.manualBreakForm.note || "").trim();
      const evidenceReference = (this.manualBreakForm.evidenceReference || "").trim();
      return !!(
        validDuration &&
        note &&
        evidenceReference &&
        (duration !== 0 || this.isSelectedTalentOnABreak)
      );
    },
    hygienistDetails() {
      if (!this.HygienistForDispute[0]) return {};
      const h = this.HygienistForDispute[0];
      const membership = this.selectedMembership;
      const presentationCode = resolveCanonicalFfsPresentationCode(
        membership && membership.currentStatusCode,
        membership && membership.overlay && membership.overlay.active
          ? membership.overlay.state
          : null
      );
      return {
        ID: h.id,
        Status: presentationCode
          ? getFfsStatusLabel(presentationCode)
          : (membership && membership.displayLabel) || "N/A",
        Type: constants.hygienistType[h.type] || "N/A",
        "First Name": h.firstName,
        "Last Name": h.lastName,
        Email: h.email,
        Phone: h.phone,
        Address: `${h.address}, ${h.city}, ${h.province}`,
        "Graduation Year": h.graduationYear,
        School: h.school,
        "is Dupe": h.isDupe
      };
    },
    locationDetails() {
      if (!this.LocationForDispute[0]) return {};
      const l = this.LocationForDispute[0];
      return {
        ID: l.id,
        "Practice Name": l.practiceName,
        Email: l.email,
        Phone: l.phone,
        Address: `${l.address}, ${l.city}, ${l.province}`
      };
    }
  },
  methods: {
    ...mapActions([
      "getCommentsForDispute",
      "updateDonationAmount",
      "getDataForDispute"
    ]),
    ...mapMutations(["callSnackbar", "modifyBlockedUntil"]),
    dateCalc: job => {
      let hours =
        (Date.parse(job.postedStart) - Date.parse(job.cancelTimestamp)) /
        (60 * 60 * 1000);
      const minus = hours < 0;
      hours = minus ? parseInt(0 - hours) : parseInt(hours);
      const string =
        hours > 24 || hours < -24
          ? `${parseInt(hours / 24)}d ${hours % 24}h`
          : `${hours}h`;
      return `(${string + (minus ? " after" : " before")})`;
    },

    showDonation(stat) {
      const hygienist = this.HygienistForDispute[0];
      return (
        !hygienist["donationTimeStamp"] &&
        hygienist["donationAmount"] &&
        (hygienist.Status === "Blacklisted" ||
          hygienist.Status === "Revoked") &&
        stat === "Status"
      );
    },

    showCancelled(stat) {
      const hygienist = this.HygienistForDispute[0];
      return (
        (hygienist.cancelled.length || hygienist.ignoredCancelled.length) &&
        stat === "# of Cancelled"
      );
    },

    showTwoRatings(stat) {
      const hygienist = this.HygienistForDispute[0];
      return hygienist.twoStarJobs.length && stat === "# of Ratings = 2";
    },

    showValue(stat) {
      const hygienist = this.HygienistForDispute[0];
      switch (stat) {
        case "Status":
          return {
            value: "",
            class: hygienist["Status"]
          };
        case "# of Ratings = 5":
          return {
            value: "80.0%",
            class:
              hygienist["% of Ratings = 5"] > 80.0
                ? "green--text"
                : "orange--text",
            text: `${hygienist.firstName} needs to complete ${this.star5Pro} more shifts with 5-star reviews to earn Pro/Elite in this category.`,
            displayText: hygienist["% of Ratings = 5"] < 80.0
          };
        case "# of Ratings = 2":
          return {
            value: "3.0%",
            class:
              hygienist["% of Ratings = 2"] < 3.0
                ? "green--text"
                : "orange--text",
            text: `${hygienist.firstName} needs to complete ${this.star2Pro} more shifts without receiving a 2-star review to earn Pro/Elite in this category.`,
            displayText: hygienist["% of Ratings = 2"] > 3.0
          };
        case "# of Cancelled":
          return {
            value: "3.0%",
            class:
              hygienist["% cancelled"] < 3.0 ? "green--text" : "orange--text",
            text: `${hygienist.firstName} needs to complete ${this.cancellationsPro} more shifts without cancelling to earn Pro/Elite in this category.`,
            displayText: hygienist["% cancelled"] > 3.0
          };
        default:
          return {
            value: "",
            class: "",
            text: "",
            displayText: false
          };
      }
    },

    copy(text) {
      navigator.permissions.query({ name: "clipboard-write" }).then(result => {
        if (result.state == "granted" || result.state == "prompt") {
          navigator.clipboard.writeText(text).then(
            () => {
              /* clipboard successfully set */
              this.callSnackbar({
                visible: true,
                text: "Copied",
                color: "primary"
              });
            },
            function() {
              /* clipboard write failed */
            }
          );
        }
      });
    },

    resetManualBreakForm() {
      this.manualBreakForm = {
        durationMonths: 3,
        note: "",
        evidenceReference: ""
      };
    },

    async openManualBreakDialog() {
      if (!this.HygienistForDispute[0]) return;

      this.manualBreakDialogLoading = true;
      this.manualBreakProfile = null;

      try {
        this.manualBreakProfile = await getHygienistProfile(
          this.HygienistForDispute[0].id
        );
      } catch {
        this.snack = true;
        this.snackColor = "warning";
        this.snackText = "Profile details unavailable; break removal disabled";
      } finally {
        this.resetManualBreakForm();
        this.manualBreakIdempotencyKey = createAdminSourceCorrectionIdempotencyKey(
          "dispute-manual-break"
        );
        this.manualBreakDialogLoading = false;
        this.manualBreakDialog = true;
      }
    },

    closeManualBreakDialog() {
      if (this.isApplyingManualBreak) return;

      this.manualBreakDialog = false;
      this.resetManualBreakForm();
      this.manualBreakIdempotencyKey = "";
    },

    async submitManualBreak() {
      if (!this.HygienistForDispute[0]) return;

      if (!this.canApplyManualBreak) {
        this.snack = true;
        this.snackColor = "warning";
        this.snackText = "Break duration, support note, and evidence reference are required";
        return;
      }

      const durationMonths = Number(this.manualBreakForm.durationMonths);
      const note = (this.manualBreakForm.note || "").trim();
      const evidenceReference = (this.manualBreakForm.evidenceReference || "").trim();

      try {
        this.isApplyingManualBreak = true;
        const result = await applyManualBreak(this.HygienistForDispute[0].id, {
          durationMonths,
          note,
          evidenceReference
        }, this.manualBreakIdempotencyKey);

        if (result && result.membership) {
          this.manualBreakProfile = Object.assign(
            {},
            this.manualBreakProfile || {},
            {
              membership: result.membership
            }
          );
        }

        this.manualBreakDialog = false;
        this.resetManualBreakForm();
        await this.sentSuccess(
          durationMonths === 0
            ? "Take a Break removed"
            : `Take a Break updated for ${durationMonths} months`
        );
      } catch (error) {
        const message =
          error && error.message
            ? error.message
            : "Error applying Take a Break";
        this.sentFailed(message);
      } finally {
        this.isApplyingManualBreak = false;
      }
    },

    // T2-6395/T2-6381: only the "First Response" flow (type 0) remains; the
    // type-3 Quiz-Received branch and its cancellationCode/reinstatementCode
    // lookup were removed.
    showModal(type, title) {
      this.actionDialogTitle = title;
      this.actionDialog = true;
      this.formType = type;
      this.courseError = false;
      this.actionDialogSubTitle = false;
    },

    async popFormSubmit() {
      try {
        const response = await updateCourseDisputeAnalyzer({
          hygId: this.HygienistForDispute[0].id,
          userName: this.HygienistForDispute[0].firstName,
          userEmail: this.HygienistForDispute[0].email,
          formType: this.formType,
          templateMessage: this.selectFirstResponse_radio,
          notesToMember: this.selectFirstResponse_NotesToMember,
          internalNotes: this.selectFirstResponse_InternalNotes,
          ticketNumber: this.selectFirstResponse_TicketNumber
        });
        if (response && response.status >= 400) throw new Error();

        this.closeModal();
        this.sentSuccess();
      } catch (error) {
        this.sentFailed();
      }
    },

    closeModal() {
      this.actionDialog = false;
      setTimeout(() => {
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
      }, 1);
    },

    dissableSubmit() {
      return !this.selectFirstResponse_radio;
    },

    async sentSuccess(message = "OK") {
      await this.getDataForDispute({
        ...(this.HygienistForDispute[0] && {
          hygienist: {
            id: this.HygienistForDispute[0].id
          }
        }),
        ...(this.LocationForDispute[0] && {
          location: {
            id: this.LocationForDispute[0].id
          }
        })
      });
      this.snack = true;
      this.snackColor = "success";
      this.snackText = message;
    },

    sentFailed(message = "Error") {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = message;
    },

    fullNameStatusCode(code) {
      return constants.statusCodes.filter(i => i.code === code)[0].explanation;
    },

    dateComparison(dateFirst, dateSecond) {
      const dFirst = new Date(dateFirst).getTime();
      const dSecond = new Date(dateSecond).getTime();
      if (dFirst >= dSecond) {
        return dateFirst;
      }
      return dateSecond;
    },

    formatDateTime(date) {
      return format(
        utcToZonedTime(date, currentTimeZone()),
        "yyyy-MM-dd HH:mm:ss"
      );
    },

    editNotes(titleNotes, obj) {
      this.dialogNotes = true;
      this.modalNotes = titleNotes === "Hygienist" ? obj.Notes : obj.notes;
      this.modalNotesTitle = titleNotes;
      this.currentDispute = obj;
    },

    async saveNotes() {
      try {
        await updateTable({
          tablename: this.modalNotesTitle,
          columnname: this.modalNotesTitle === "Hygienist" ? "Notes" : "notes",
          id: this.currentDispute.id,
          value: this.modalNotes,
          prevValue:
            this.modalNotesTitle === "Hygienist"
              ? this.currentDispute.Notes
              : this.currentDispute.notes
        });
        this.dialogNotes = false;
        this.sentSuccess();
      } catch (error) {
        this.sentFailed();
      }
    },

    // T2-6380: changeStatus() / submitStatus() removed with the "Change status"
    // dialog (Fair Fresh Start owns membership status).

    async saveHygienistData(newValue, columnName) {
      try {
        await updateTable({
          tablename: "Hygienist",
          columnname: columnName,
          id: this.currentDispute.ID,
          value: newValue,
          prevValue: this.currentDispute[columnName]
        });

        this.sentSuccess();
      } catch (error) {
        this.sentFailed();
      }
    },

    async saveResumeUrl() {
      const selectedFile = this.file;
      const fileType = selectedFile.name.split(".").pop();

      const fileWithNewName = new File(
        [selectedFile],
        selectedFile.name.split(".").slice(0, -1),
        {
          type: selectedFile.type
        }
      );

      try {
        const fileURL = await uploadToS3(fileWithNewName, fileType);
        await updateResumeURL({
          tableName: "Hygienist",
          id: this.currentDispute.ID,
          column: "resumeUrl",
          fileURL
        });

        this.sentSuccess();
      } catch (error) {
        this.sentFailed();
      }
    },
    isEditableHygienistField(key) {
      const editableFields = [
        "Status",
        "Keep Status",
        "Blocked Until",
        "CDHO Number",
        "Max Booked",
        "Resume Url",
        "School",
        "Graduation Year"
      ];
      return editableFields.includes(key);
    },

    // Stats dialog methods
    async openStatsDialog() {
      if (!this.HygienistForDispute[0]) return;
      
      this.showStatsDialog = true;
      this.loadingStats = true;
      this.talentStats = null;

      try {
        const stats = await getHygienistStats(this.HygienistForDispute[0].id);
        this.talentStats = stats;
      } catch (error) {
        console.error("Failed to fetch talent stats:", error);
        this.talentStats = null;
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Failed to load stats";
      } finally {
        this.loadingStats = false;
      }
    },

    // T2-6379: FFS card helpers (shared palette/labels/icons).
    ffsColor(code) {
      return getFfsStatusColor(code);
    },
    ffsLabel(code) {
      return getFfsStatusLabel(code);
    },
    ffsIcon(code) {
      return getFfsStatusIcon(code);
    },
    ffsDarkText(code) {
      return ffsStatusNeedsDarkText(code);
    },
    ffsNum(value) {
      if (value === null || value === undefined || isNaN(Number(value))) {
        return "N/A";
      }
      const num = Number(value);
      return Number.isInteger(num) ? String(num) : num.toFixed(2);
    },

    formatFairFreshStartStatusCode(statusCode) {
      if (!statusCode) return "N/A";
      const labels = {
        Elite: "Elite",
        Pro: "Pro",
        Active: "Active",
        Probation: "Probation",
        CourseRequired: "Course Required",
        RL1: "Reliability Limited 1",
        RL2: "Reliability Limited 2",
        FL1: "Feedback Limited 1",
        FL2: "Feedback Limited 2",
        RL1FL1: "Reliability 1 / Feedback 1",
        RL1FL2: "Reliability 1 / Feedback 2",
        RL2FL1: "Reliability 2 / Feedback 1",
        RL2FL2: "Reliability 2 / Feedback 2"
      };
      return labels[statusCode]
        || String(statusCode).replace(/([a-z])([A-Z])/g, "$1 $2").replace(/_/g, " ");
    },

    getFairFreshStartVisibleLabel(fairFreshStart) {
      if (!fairFreshStart) return "N/A";
      return fairFreshStart.status?.displayLabel
        || this.formatFairFreshStartStatusCode(
          fairFreshStart.status?.currentStatusCode
        );
    },

    getFairFreshStartRawLabel(fairFreshStart) {
      if (!fairFreshStart) return "N/A";
      return this.formatFairFreshStartStatusCode(
        fairFreshStart.status?.grandfathering?.calculatedStatusCode
        || fairFreshStart.grandfathering?.calculatedStatusCode
        || fairFreshStart.status?.rawStatusCode
        || fairFreshStart.status?.currentStatusCode
      );
    },

    getFairFreshStartProtectedLabel(fairFreshStart) {
      if (!fairFreshStart) return "N/A";
      return this.formatFairFreshStartStatusCode(
        fairFreshStart.status?.grandfathering?.protectedStatusCode
        || fairFreshStart.grandfathering?.protectedStatusCode
        || fairFreshStart.status?.currentStatusCode
      );
    },

    isFairFreshStartProtected(fairFreshStart) {
      if (fairFreshStart?.status?.grandfathering?.active) return true;
      if (fairFreshStart?.grandfathering?.isActive) return true;
      if (!fairFreshStart?.grandfathering?.protectedStatusCode || !fairFreshStart.grandfathering.grandfatheredUntil) {
        return false;
      }
      const untilTimestamp = Date.parse(fairFreshStart.grandfathering.grandfatheredUntil);
      return Number.isFinite(untilTimestamp) && untilTimestamp > Date.now();
    },

    getFairFreshStartStatusColor(fairFreshStart) {
      if (this.isFairFreshStartProtected(fairFreshStart)) return "amber darken-2";
      const statusCode = fairFreshStart?.status?.currentStatusCode;
      if (statusCode) return this.ffsColor(statusCode);
      const label = this.getFairFreshStartVisibleLabel(fairFreshStart).toLowerCase();
      if (label.includes("elite")) return "purple";
      if (label.includes("active")) return "green";
      if (label.includes("course") || label.includes("probation")) return "orange darken-1";
      if (label === "pro") return "#0B4598";
      if (label.includes("limited") || label.includes("not a fit") || label.includes("break")) return "red darken-1";
      return "grey";
    },

    formatFairFreshStartMetric(value, digits = 2) {
      if (value === null || typeof value === "undefined") return "N/A";
      const numericValue = Number(value);
      return Number.isFinite(numericValue) ? numericValue.toFixed(digits) : "N/A";
    },

    formatFairFreshStartPercentile(value, label) {
      if (value === null || typeof value === "undefined") return label || "N/A";
      return label ? `${value} (${label})` : `${value}`;
    },

    getFairFreshStartCompletedShifts(fairFreshStart) {
      const value = fairFreshStart?.status?.completedShifts ?? fairFreshStart?.reliability?.completedShifts;
      return value === null || typeof value === "undefined" ? "N/A" : String(value);
    },

    getFairFreshStartRatedShifts(fairFreshStart) {
      const value = fairFreshStart?.status?.ratedShifts ?? fairFreshStart?.feedback?.ratedShifts;
      return value === null || typeof value === "undefined" ? "N/A" : String(value);
    },

    getFairFreshStartFeedbackCount(fairFreshStart) {
      const value = fairFreshStart?.feedback?.feedbackCount
        ?? fairFreshStart?.feedback?.ratedShifts
        ?? fairFreshStart?.status?.ratedShifts;
      return value === null || typeof value === "undefined" ? "N/A" : String(value);
    },

    getStarColor(score) {
      if (score === null) return "grey";
      if (score >= 4.5) return "#4CAF50";
      if (score >= 4.0) return "#8BC34A";
      if (score >= 3.5) return "#FF9800";
      return "#F44336";
    },

    getValueGivesColor(value) {
      if (value === null) return "grey";
      if (value >= 0) return "#4CAF50";
      if (value >= -5) return "#FF9800";
      return "#F44336";
    },

    getCancellationColor(percentage) {
      if (percentage === null) return "grey";
      if (percentage <= 5) return "#4CAF50";
      if (percentage <= 10) return "#8BC34A";
      if (percentage <= 15) return "#FF9800";
      return "#F44336";
    }
  }
};
</script>

<style scoped>
.v-timeline-item {
  padding-bottom: 15px !important;
}

.ffs-status-card {
  border-color: rgba(11, 69, 152, 0.24) !important;
}
</style>
